import React from 'react';
import { motion } from 'framer-motion';

const cardVariants = {
  hidden: { opacity: 0, y: 20, scale: 0.98 },
  visible: { opacity: 1, y: 0, scale: 1 },
};

export default function GalleryCard({ item, index, onOpen }) {
  const { title, imageUrl, posterUrl, previewUrl, tags, date, type } = item;

  return (
    <motion.article
      className="relative break-inside-avoid rounded-xl overflow-hidden bg-white/5 border border-white/10 shadow-lg hover:shadow-xl transition-shadow"
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.35, delay: index * 0.04 }}
    >
      <button
        type="button"
        onClick={onOpen}
        className="group w-full text-left"
        aria-label={`Open ${title}`}
      >
        <div className="relative">
          {type === 'video' ? (
            <>
              <img
                src={posterUrl || imageUrl}
                alt={title}
                loading="lazy"
                className="w-full h-auto object-cover"
              />
              {previewUrl && (
                <video
                  className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity"
                  src={previewUrl}
                  muted
                  loop
                  playsInline
                  autoPlay
                  preload="metadata"
                />
              )}
            </>
          ) : (
            <img
              src={imageUrl}
              alt={title}
              loading="lazy"
              className="w-full h-auto object-cover"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
          {type === 'video' && (
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-black/50 border border-white/20 text-white shadow-lg group-hover:scale-105 transition-transform">▶</span>
            </div>
          )}
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-white text-lg font-bold drop-shadow">
              {title}
            </h3>
            <p className="text-white/80 text-xs mt-1">
              {new Date(date).toLocaleDateString()}
            </p>
            <div className="mt-2 flex flex-wrap gap-2">
              {tags.map((t) => (
                <span key={t} className="text-[10px] px-2 py-1 rounded-full bg-cyan-500/20 text-cyan-200 border border-cyan-400/20">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </button>
    </motion.article>
  );
}
